export const KeyValueItem = ({
  label,
  value,
  postfix,
  align,
}: {
  label?: string;
  value?: string | number;
  postfix?: string;
  align?: "row" | "column";
}) => {
  return (
    <div
      className={`flex text-base ${align === "column" ? " items-start flex-col gap-0" : "flex-row gap-2 items-center"}`}
    >
      <dt className="font-semibold">{label}:</dt>
      <dd className="m-0 whitespace-pre-line break-all text-pretty">
        {value + (postfix ? ` ${postfix}` : "")}
      </dd>
    </div>
  );
};
